<section aria-label="collaboration settings">
  <div class="row">
    <div class="col-12">
      <myp-collaboration-invite-notice></myp-collaboration-invite-notice>
      <fui-heading [text]="'sphere.workspaces.collaboration_settings' | translate" [level]="5"></fui-heading>
      @if (!loading && (!workspaces || !workspaces.length)) {
        <div class="m-y-20">
          {{ "sphere.workspaces.collab_settings_msg" | translate }}
        </div>
      }
      @if (loading) {
        <myp-inline-loader [loading]="loading" height="400px" spinnerName="collab-notifications"></myp-inline-loader>
      }

      @if (!loading && workspaces && workspaces.length) {
        <div class="m-y-20">
          @for (item of workspaces; track item) {
            <myp-list-item [item]="item" [includeChevron]="false" [showImage]="false" [title]="item.name" [imageRound]="false" [collapsible]="true" [showBackground]="true" marginBottom="10px">
              <div class="collapsible-content">
                <div class="d-flex align-items-start">
                  <input type="radio" class="m-r-8 m-t-5" (change)="togglePreference(item)" [checked]="preferences[item.id].subscribed" [name]="item.id + '_select'" [id]="item.id + '_select'" />
                  <label [for]="item.id + '_select'">{{ "sphere.workspaces.collab_msg_on" | translate }}</label>
                </div>
                <div class="d-flex align-items-start">
                  <input type="radio" class="m-r-8 m-t-5" (change)="togglePreference(item)" [checked]="!preferences[item.id].subscribed" [name]="item.id + '_select'" [id]="item.id + '_select'" />
                  <label [for]="item.id + '_select'">{{ "sphere.workspaces.collab_msg_off" | translate }}</label>
                </div>
              </div>
            </myp-list-item>
          }
        </div>
      }
    </div>
  </div>
</section>
